export enum UserRolesType {
  AUXILIA_ADMIN = 'AuxiliaAdmin',
  SUPER_ADMIN = 'SuperAdmin',
  CLIENT_ADMIN = 'ClientAdmin',
  FUNDRAISING_MANAGER = 'FundraisingManager',
  CONTENT_CREATOR = 'ContentCreator',
  DONOR_ADMIN = 'DonorAdmin',
  DONOR_MANAGER = 'DonorManager'
}
